import { InjectionToken, inject } from '@angular/core';
import { WebRsaCryptoAdapter } from './adapters/web-rsa-crypto.adapter';
import { IRsaCryptoPort } from './port/rsa-crypto.port';

export const RSA_CRYPTO_PROVIDER = new InjectionToken<IRsaCryptoPort>(
  'RSA_CRYPTO_PROVIDER',
  {
    providedIn: 'root',
    factory: () => inject(WebRsaCryptoAdapter),
  },
);
